import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { InputLabel } from "@material-ui/core";

import { HouseFuseIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { InfoBox } from "../core/InfoBox";

export const IncreaseCurrentHouseConnectionFuseCapacityForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.INCREASE_CURRENT_HOUSE_CONNECTION_FUSE_CAPACITY>();
    return (
        <Fragment>
            <h3 className={classes.h3} style={{ marginTop: 28, marginBottom: 16 }}>
                Ist Ihnen die Größe der Hausanschlusssicherung bekannt?
            </h3>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HouseFuseIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Hausanschlusssicherung
                        </p>
                        <p className={classes.p} style={{ marginTop: 0, marginBottom: 24 }}>
                            Beachten Sie, das Öffnen des Hausanschlusskastens ist ausschließlich
                            durch einen konzessionierten Elektroinstallateur gestattet. Die Größe
                            der Hausanschlusssicherung erhalten Sie ggf. von Ihrem
                            Elektroinstallateur.
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseCurrentHouseConnectionFuseCapacity.value.installed}
                        {...getFieldProps(
                            "increaseCurrentHouseConnectionFuseCapacity.value.installed",
                        )}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseCurrentHouseConnectionFuseCapacity.value.installed =
                                    checked;
                                values.increaseCurrentHouseConnectionFuseCapacity.value.current.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.increaseCurrentHouseConnectionFuseCapacity.value.installed}
                detail={
                    <Fragment>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Sicherungsgröße
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.increaseCurrentHouseConnectionFuseCapacity.value.current
                                    .precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={
                                values.increaseCurrentHouseConnectionFuseCapacity.value.current.unit
                            }
                            value={
                                values.increaseCurrentHouseConnectionFuseCapacity.value.current
                                    .amount || ""
                            }
                            placeholder="0"
                            onValueChange={(v) =>
                                setValues((values) => {
                                    values.increaseCurrentHouseConnectionFuseCapacity.value.current.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.increaseCurrentHouseConnectionFuseCapacity.error != null}
                        />
                    </Fragment>
                }
            />
            <InfoBox title="Hinweis">
                <p>
                    Bitte beachten, dass elektrische Anlagen und Verbrauchsgeräte nach VDE-AR-N 4100
                    und der aktuellen gültigen TAB der Syna entsprechend anzumelden sind!
                    <br />
                    Verwenden Sie hierzu das Datenblatt{" "}
                    <a href="https://www.syna.de/content/dam/syna-de/dokumente/netzanschluss/anschlussbedingungen/b1-datenblatt-zur-beurteilung-von-netzrueckwirkungen.pdf">
                        Beurteilung von Netzrückwirkungen
                    </a>{" "}
                    auf unserer Homepage und fügen Sie dieses bitte dem Antrag unter "Optionale
                    Dokumente" hinzu.
                </p>
            </InfoBox>
        </Fragment>
    );
};
